/**
 * SupportScreen (/support/*) — shell for the support ticket area. Mirrors the
 * Correspondents screen: a set of nested routes for the list, the new-ticket
 * form, and per-ticket detail. Mounted at /support/* in index.js.
 *
 *   index   → SupportListPage      (board; defaults to everyone, toggle to mine)
 *   new     → SupportNewTicketPage (full-page intake form)
 *   :id     → SupportTicketDetailPage
 */
import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import { useDocumentTitle } from "../../hooks/useDocumentTitle";

const SupportListPage = lazy(() => import("./pages/SupportListPage"));
const SupportNewTicketPage = lazy(() => import("./pages/SupportNewTicketPage"));
const SupportTicketDetailPage = lazy(() => import("./pages/SupportTicketDetailPage"));

const Fallback = () => (
  <Box sx={{ display: "grid", placeItems: "center", minHeight: 200, py: 4 }}>
    <CircularProgress size={24} />
  </Box>
);

const SupportScreen = () => {
  useDocumentTitle("Support");

  return (
    <Box
    sx={{
      width: "100%",
      height: "100%",
      minHeight: 0,
      overflowY: "auto",
      bgcolor: "#f6f9fa",
    }}
  >
    <Suspense fallback={<Fallback />}>
      <Routes>
        <Route index element={<SupportListPage />} />
        <Route path="new" element={<SupportNewTicketPage />} />
        <Route path=":id" element={<SupportTicketDetailPage />} />
      </Routes>
      </Suspense>
    </Box>
  );
};

export default SupportScreen;
